import create from 'zustand';
import {axios} from "@/lib/axios";
import * as Config from "@/config";
import {LoadingStore} from "@/stores/loading";
import {MessageModalStore} from "@/stores/message";

interface User {
  id: number,
  login_id: string,
  customer_number?: string,
  customer_type_id?: string,
  customer_group_type_id?: string,
  customer_payment_type_id?: string,
  business_entity_type?: string,
  corporate_number?: string,
  group_name?: string,
  station_name?: string,
  department_name?: string,
  unit_name?: string,
  section_name?: string,
  position?: string,
  last_name?: string,
  first_name?: string,
  reading_last_name?: string,
  reading_first_name?: string,
  phone_number?: string,
  emergency_phone_number?: string,
  zipcode?: string,
  pref?: string,
  city?: string,
  house_number?: string,
  building_name?: string,
  email_address?: string,
  billing_post_type?: string,
  billing_post_group_name?: string,
  billing_post_department_name?: string,
  billing_post_last_name?: string,
  billing_post_first_name?: string,
  billing_post_phone_number?: string,
  billing_post_zipcode?: string,
  billing_post_pref?: string,
  billing_post_city?: string,
  billing_post_house_number?: string,
  billing_post_building_name?: string,
  approval_status?: string,
}

type UserStore = {
  user: User | undefined;
  setUser: (user: User | undefined) => void;
  fetchUser: (setLoading: LoadingStore['setLoading'], setMessage: MessageModalStore['setMessage']) => void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: undefined,
  setUser: (user) =>
    set((state) => ({
      user: user,
    })),
  fetchUser: (setLoading, setMessage) => {
    setLoading(true);
    axios.post('/api/v1/customers/getLoginUserInfo').then(result => {
      set({user: result.data})
    }).catch(error => {
      setMessage(Config.MESSAGE_NO_E39);
    }).finally(() => {
      setLoading(false);
    });
  },
}));
